(function () {
  // Only run on homepage
  const isHome =
    document.body.classList.contains("template-index") ||
    window.location.pathname === "/";

  if (!isHome) return;

  const logo = document.querySelector("[data-scroll-logo]");
  if (!logo) return;

  const startScale = parseFloat(logo.getAttribute("data-scale-start")) || 3;
  const endScale = 1;
  const animationDistance = 400; // tweak if you want slower/faster

  let startTranslateY = window.innerHeight * 0.8; // start near bottom
  let latestScrollY = window.scrollY;
  let ticking = false;

  function updateMeasurements() {
    startTranslateY = window.innerHeight * 0.8;
  }

  function applyTransform() {
    const scrollY = latestScrollY;

    const rawProgress = scrollY / animationDistance;
    const progress = Math.max(0, Math.min(1, rawProgress));

    const scale = startScale + (endScale - startScale) * progress;
    const translateY = startTranslateY * (1 - progress);

    logo.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;

    ticking = false;
  }

  function onScroll() {
    latestScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(applyTransform);
      ticking = true;
    }
  }

  updateMeasurements();
  applyTransform();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    updateMeasurements();
    applyTransform();
  });
})();
